import mutations from './auth.mutations';
import actions from './auth.actions';
import getters from './auth.getters';
import state from './auth.state';

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/auth/index.js